let epeida_url_config = "https://jiarise.cn/sjmj-epeida-api"
// let epeida_url_config = "https://uat.szepeida.com/epeida-service"



export default epeida_url_config